import { useState } from "react";
import { useMediaUrl } from "../lib/useMediaUrl";
import { LoadingImage } from "./Loading";

/** "Avi Yesawich" → "AY"; one word → its first letter. */
export function initials(name: string) {
  const words = name.trim().split(/\s+/).filter(Boolean);
  if (!words.length) return "?";
  const first = words[0][0] ?? "";
  const last = words.length > 1 ? words[words.length - 1][0] ?? "" : "";
  return (first + last).toUpperCase();
}

export type AvatarSize = "sm" | "md" | "lg" | "story";

/** A member's photo, or their initials when there is none or it fails to load. Shares the
 * signed-media cache with feed media so the same photo is signed once. */
export function PersonAvatar({ media, name, size = "md", label }: { media?: string | null; name: string; size?: AvatarSize; label?: string }) {
  const signed = useMediaUrl(media);
  const [failed, setFailed] = useState<string | null>(null);
  const className = `ll-avatar ll-avatar--${size}`;
  if (media && signed.data && failed !== signed.data)
    return (
      <LoadingImage className={`${className} ll-avatar--photo`} src={signed.data} alt={label ?? ""} aria-hidden={label ? undefined : true}
        onError={() => setFailed(signed.data!)} />
    );
  return (
    <span className={className} role={label ? "img" : undefined} aria-label={label} aria-hidden={label ? undefined : true}>
      {initials(name)}
    </span>
  );
}
